var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIconSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 8,
    fill: "#4285F4",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 12.625C22.75 12.5256 22.7105 12.4302 22.6402 12.3599C22.5698 12.2895 22.4745 12.25 22.375 12.25H20.5C19.5558 12.203 18.6314 12.5316 17.9288 13.164C17.2261 13.7964 16.8023 14.6812 16.75 15.625V17.65H14.875C14.7755 17.65 14.6802 17.6895 14.6098 17.7599C14.5395 17.8302 14.5 17.9256 14.5 18.025V19.975C14.5 20.0745 14.5395 20.1699 14.6098 20.2402C14.6802 20.3105 14.7755 20.35 14.875 20.35H16.75V25.375C16.75 25.4745 16.7895 25.5699 16.8598 25.6402C16.9302 25.7105 17.0255 25.75 17.125 25.75H19.375C19.4745 25.75 19.5698 25.7105 19.6402 25.6402C19.7105 25.5699 19.75 25.4745 19.75 25.375V20.35H21.715C21.7984 20.3512 21.8798 20.3246 21.9464 20.2743C22.0129 20.2241 22.0608 20.1531 22.0825 20.0725L22.6225 18.1225C22.6374 18.0671 22.6394 18.009 22.6284 17.9527C22.6173 17.8964 22.5935 17.8434 22.5587 17.7978C22.5239 17.7521 22.4791 17.7151 22.4278 17.6895C22.3764 17.6638 22.3199 17.6504 22.2625 17.65H19.75V15.625C19.7687 15.4394 19.8558 15.2674 19.9945 15.1426C20.1332 15.0177 20.3134 14.9491 20.5 14.95H22.375C22.4745 14.95 22.5698 14.9105 22.6402 14.8402C22.7105 14.7699 22.75 14.6745 22.75 14.575V12.625Z",
    fill: "#4285F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIconSmall);
export default __webpack_public_path__ + "static/media/FacebookIcon_small.86f34d01.svg";
export { ForwardRef as ReactComponent };